import React from "react";
import { Outlet, Navigate, useLocation, NavLink } from "react-router-dom";
import { cn } from "../../../lib/utils/cn";
import { ADMINISTRATION_MENU_ITEMS } from "../organization-menu-config";

export const AdministrationPage: React.FC = () => {
	const location = useLocation();
	const isRootPath = location.pathname === "/organisation/administration";

	if (isRootPath) {
		return <Navigate to="/organisation/administration/firmenangaben" replace />;
	}

	return (
		<div className="flex h-full">
			<nav className="w-48 h-full border-r border-gray-200 bg-gray-50">
				<ul className="py-2">
					{ADMINISTRATION_MENU_ITEMS.map((item) => (
						<li key={item.path}>
							<NavLink
								to={item.path}
								className={({ isActive }) =>
									cn(
										"block px-4 py-2 text-sm hover:bg-gray-100 transition-colors",
										isActive && "bg-white font-medium border-l-2 border-blue-500"
									)
								}
							>
								{item.title}
							</NavLink>
						</li>
					))}
				</ul>
			</nav>
			<div className="flex-1 overflow-auto">
				<Outlet />
			</div>
		</div>
	);
};